export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/sedan.f2a9d469.svg","height":28,"width":88,"blurWidth":0,"blurHeight":0};